import React from 'react';
import { Checkbox, Grid } from 'semantic-ui-react';
import { SlideDown } from 'react-slidedown';
import { connect } from 'react-redux';
import { find, isNil, sortBy } from 'lodash';
import SortingBox from '../SortingBox';
import ReorderTool from '../ReorderTool';

import {
  setActiveStimuliId,
  stimuliSortingDownHandler,
  stimuliSortingUpHandler
} from '../../../data/analysis/stimuliActions';

class StimuliBox extends SortingBox {
  constructor(props) {
    super(props);

    this.state = {
      hidden: true
    };

    this.setVisibleSection = this.setVisibleSection.bind(this);

    this.upHandler = this.upHandler.bind(this);
    this.downHandler = this.downHandler.bind(this);
    this.clearHandler = this.clearHandler.bind(this);
  }

  setVisibleSection() {
    this.setState(prevState => ({
      hidden: !this.prevState.hidden
    }));
  }

  upHandler() {
    this.props.dispatch(stimuliSortingUpHandler());
  }

  downHandler() {
    this.props.dispatch(stimuliSortingDownHandler());
  }

  clearHandler() {
    this.props.dispatch(setActiveStimuliId(null));
  }

  setActiveStimuli(id) {
    this.props.dispatch(setActiveStimuliId(id));
  }

  render() {
    const sliderState = !this.props.layer && this.state.hidden;

    return (
      <div className="configurationBox">
        <Grid>
          <Grid.Row className="parameterHeader">
            <Grid.Column width={2} className="stepBox">
              3
            </Grid.Column>
            <Grid.Column width={12}>Stimuli</Grid.Column>
            <Grid.Column width={2} className={`toggle ${this.state.hidden ? 'closed' : ''}`}>
              <i className="icon icon-play3 clickable" onClick={this.setVisibleSection} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <ReorderTool
          upHandler={this.upHandler}
          downHandler={this.downHandler}
          clearHandler={this.clearHandler}
        />
        <SlideDown closed={sliderState} className="boxContent">
          <Grid className="layersList">
            {sortBy(this.props.stimuli, stimuli => {
              return this.props.stimuliSorting.indexOf(stimuli.id);
            }).map(item => {
              let constructClassName = 'layer clickable';
              constructClassName += this.props.activeStimuliId === item.id ? ' active' : '';
              // let iconClassName = 'iconContainer';
              // iconClassName += index !== this.state.selected ? ' disabled' : '';

              return (
                <Grid.Row
                  className={constructClassName}
                  key={item.id}
                  onClick={() => {
                    this.setActiveStimuli(item.id);
                  }}
                >
                  <Grid.Column width={3}>
                    <img alt="thumbnail url" src={item.thumbnail_url} />
                  </Grid.Column>
                  <Grid.Column width={10}>{item.name}</Grid.Column>
                  <Grid.Column width={3} className="checkboxContainer">
                    <Checkbox />
                  </Grid.Column>
                </Grid.Row>
              );
            })}
          </Grid>
        </SlideDown>
      </div>
    );
  }
}

export default connect(state => ({
  layer: (() => {
    const { activeLayerId } = state.analysis.single;
    return find(state.analysis.single.layers, { id: activeLayerId });
  })(),
  stimuli: state.analysis.single.stimuli,
  activeStimuliId: state.analysis.single.activeStimuliId,
  stimuliSorting: (() => {
    const { activeLayerId } = state.analysis.single;
    if (isNil(activeLayerId) || !(activeLayerId in state.analysis.single.stimuliSorting)) {
      return [];
    }
    return state.analysis.single.stimuliSorting[activeLayerId];
  })(),
  activeLayerId: state.analysis.single.activeLayerId
}))(StimuliBox);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/StimuliBox.js